import React, { useState, useEffect, useRef } from 'react'
import cssCreateAccount from './CreateAccount.module.scss'

import {LoadingMask, AlertWindow, CredentialMultiInWindow, AAALibs, GlobalLibs, NetworkLibs, RoutePathLibs, PackageVariablesLibs} from 'bc-react-package'
// #region Member Variables
let mblnIfNeed2GoToApplicationHomePage = null
let mblnInitialized = false

let mobjSignUpData = {}
// #endregion Member Variables

// #region Enumeration
// #endregion Enumeration

// #region Const
// #endregion Const


const COMP_NAME = "CreateAccount"

function CreateAccount(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)

    const [showOnFocusTitleForUserName, setShowOnFocusTitleForUserName] = useState(false)
    const [showOnFocusTitleForPassword, setShowOnFocusTitleForPassword] = useState(false)
    const [showOnFocusTitleForConfirmPassword, setShowOnFocusTitleForConfirmPassword] = useState(false)
    const [showOnFocusTitleForFirstName, setShowOnFocusTitleForFirstName] = useState(false)
    const [showOnFocusTitleForLastName, setShowOnFocusTitleForLastName] = useState(false)
    
    // #endregion Init State

    // #region Init Ref
    let mrefTxtLoginName = useRef(null)
    let mrefTxtPassword = useRef(null)
    let mrefTxtConfirmPassword = useRef(null)
    let mrefTxtFirstName = useRef(null)
    let mrefTxtLastName = useRef(null)
    // #endregion Init Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()
            }
            mblnInitialized = false
        }
    }, [props.history])

    // #region OnTapHandler

    function ValidateUserInput(UserInputData)
    {
        console.log(COMP_NAME + ".ValidateUserInput: ", UserInputData)

        // UserInputData = {
        //     "LoginName": "richard1972@gmail.com", // Email,
        //     "Password": "password", // Password,
        //     "RepeatPassword": "password", // RepeatPassword,
        //     "FirstName": "", // FirstName,
        //     "LastName": ""// LastName
        // }
        const USER_EMAIL_RULE = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/; // React warning提到  Unnecessary escape character: \@
        
        let strWarningMsg = ""
        if (UserInputData.LoginName.search(USER_EMAIL_RULE) === -1)
        {
            strWarningMsg = window.gAppUI.MSG_Alert_Msg_EmailIsFormatFail
        }
        else if ((UserInputData.Password.length < 4) || (UserInputData.Password.length > 16))
        {
            strWarningMsg = window.gAppUI.MSG_Alert_Msg_PasswordLengthIsShort
        }
        else if (UserInputData.Password !== UserInputData.RepeatPassword)
        {
            strWarningMsg = window.gAppUI.MSG_Alert_Msg_ConfirmYourPassword
        }
        else if (UserInputData.FirstName === "")
        {
            strWarningMsg = window.gAppUI.MSG_Alert_Msg_FirstNameNull
        }
        else if (UserInputData.LastName === "")
        {
            strWarningMsg = window.gAppUI.MSG_Alert_Msg_LastNameNull
        }

        return strWarningMsg
    }

    function CreateAccount(UserInputData)
    {
        const FUNC_NAME = "CreateAccount"
        // UserInputData = {
        //     "LoginName": "richard1972@gmail.com", // Email,
        //     "Password": "password", // Password,
        //     "RepeatPassword": "password", // RepeatPassword,
        //     "FirstName": "", // FirstName,
        //     "LastName": ""// LastName
        // }

        console.log(COMP_NAME + ".CreateAccount UserInputData: ", UserInputData);

            // Begin 這個 Func 需要 Retry
    // 條件：有參數(arguments)
    // 如果沒有參數，或是需要的參數已經在 call 之前紀錄在 member 變數，或是有同時呼叫 WS 的其他 Func, 就不需要利用這個寫法
    let arrArguments = NetworkLibs.GetArgumentsSinceNeedRetry(FUNC_NAME, arguments)
    console.log("arrArguments: ", arrArguments)
    if (arrArguments === null)
    {
        // 既然有傳入參數，又抓不到參數，就不能往下call，這個問題應該在開發階段發現
        console.log("Error: should not empty arguments")
        return
    }
    console.log("arrArguments[0]: ", arrArguments[0])
    let argUserInputData = arrArguments[0]
    // End 這個 Func 需要 Retry

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg);
        }
        else
        {
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_CreateUser4App);

            let objCallData = {
                "Func": "CreateUser4App",
                "LoginName": argUserInputData.LoginName,
                "Mima": argUserInputData.Password,
                "FirstName": argUserInputData.FirstName,
                "LastName": argUserInputData.LastName
            }

            let objCallbackFuncRef = CreateAccountCallback;
            let objRetryFuncRef = CreateAccount
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
            )
        }
    } // end of CreateAccount
    function CreateAccountCallback(Return)
    {
        console.log(COMP_NAME + ".CreateAccountCallback: ", Return);

        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_CreateUser4App_No
        let strErrorTitle = window.gAppUI.ERR_CreateUser4App_Title
        let strErrMsg = window.gAppUI.ERR_CreateUser4App_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                case window.gConst.WEB_GATEWAY_RETURN_ERR_CREATE_USER_REPEAT: // -140157 EmailAddr Existed 
                    strErrorTitle = window.gAppUI.ERR_CreateUser4App_Repeat_Title
                    strErrMsg = window.gAppUI.ERR_CreateUser4App_Repeat_Msg + ' (' + Return.CalledErrNo + ') '
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }
        }
        else
        {
            console.log("Successfully CreateAccountCallback Return.Data: ", Return.Data);

            CreateAccountCallbackAfterProcess()
        }
    } // end of CreateAccountCallback    

    function CreateAccountCallbackAfterProcess()
    {
        console.log(COMP_NAME + ".CreateAccountCallbackAfterProcess: ");

        let strClassName = ""
        let strUserName = mobjSignUpData.LoginName;
        let strPassword = mobjSignUpData.Password;

        AAALibs.UserLogin(strClassName, strUserName, strPassword);
    } // end of CreateAccountCallbackAfterProcess

    function CreateAccountOnTapHandler()
    {
        console.log(COMP_NAME +  ".CreateAccountOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // set Sign up data from user input
        mobjSignUpData = {
            "LoginName": mrefTxtLoginName.current.value.trim(), // "richard197201@gmail.com", // Email,
            "Password": mrefTxtPassword.current.value.trim(), // "password", // Password,
            "RepeatPassword": mrefTxtConfirmPassword.current.value.trim(), // "password", // RepeatPassword,
            "FirstName": mrefTxtFirstName.current.value.trim(), //"Richard", // FirstName,
            "LastName": mrefTxtLastName.current.value.trim(), // "Chen"// LastName
        }
        console.log("mobjSignUpData:", mobjSignUpData)
        
        // valid user input
        // invalied if return non-emptpy string
        let strWarningMsg = ValidateUserInput(mobjSignUpData)
        if (strWarningMsg === "")
        {
            console.log("User input is valid")
            // User input is valid
            CreateAccount(mobjSignUpData)
        }   
        else
        {
            // some input error
            mobjSignUpData = {}

            let objAlertObject = {
                Header: null,
                Body: strWarningMsg,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }

            ShowAlert(objAlertObject)
        }
    }

    function GoToLoginPageOnTapHandler()
    {
        console.log(COMP_NAME +  ".GoToLoginPageOnTapHandler: ")
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        RoutePathLibs.Route2Path(props.history, "/Login")
    }
    // #endregion OnTapHandler
    
    // #region Other Handler

    function UserNameOnFocusHandler(Event)
    {
        const FUNC_NAME = "UserNameOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForUserName(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function UserNameOnBlurHandler(Event)
    {
        const FUNC_NAME = "UserNameOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForUserName(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_UsernameEmailPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForUserName(false)
        }
    }

    function PasswordOnFocusHandler(Event)
    {
        const FUNC_NAME = "PasswordOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForPassword(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function PasswordOnBlurHandler(Event)
    {
        const FUNC_NAME = "PasswordOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForPassword(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_PasswordPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForPassword(false)
        }
    }

    function ConfirmPasswordOnFocusHandler(Event)
    {
        const FUNC_NAME = "ConfirmPasswordOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)
        // console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)

        setShowOnFocusTitleForConfirmPassword(true)
        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function ConfirmPasswordOnBlurHandler(Event)
    {
        const FUNC_NAME = "ConfirmPasswordOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForConfirmPassword(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_ConfirmPasswordPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForConfirmPassword(false)
        }
    }

    function FirstNameOnFocusHandler(Event)
    {
        const FUNC_NAME = "FirstNameOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForFirstName(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function FirstNameOnBlurHandler(Event)
    {
        const FUNC_NAME = "FirstNameOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForFirstName(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_FirstNamePlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForFirstName(false)
        }
    }

    function LastNameOnFocusHandler(Event)
    {
        const FUNC_NAME = "LastNameOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForLastName(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function LastNameOnBlurHandler(Event)
    {
        const FUNC_NAME = "LastNameOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForFirstName(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_LastNamePlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForLastName(false)
        }
    }

    // #endregion Other Handler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    // #endregion ComponentCallback

    // #region Other Functions
    // #endregion Other Functions

    // #region Get ClassName

    function GetClsOnFocusTitle(ShowOnFocusTitle)
    {
        const FUNC_NAME = "GetClsOnFocusTitle"
        console.log(COMP_NAME + "." + FUNC_NAME)

        let objCls = null
        if(ShowOnFocusTitle)
        {
            objCls = cssCreateAccount.divInputOnFocusTitle
        }
        else
        {
            objCls = cssCreateAccount.divHidden
        }
        return objCls
    }

    // #endregion Get ClassName

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Render

    function RenderFormContent() {
        return (
            <div className={cssCreateAccount.divContent}>
                <div className={cssCreateAccount.divTitleCreateAnAccount}>{window.gAppUI.LBL_TitleCreateAccount}</div>
                <div className={cssCreateAccount.divInput}>
                    <input ref={mrefTxtLoginName}
                        className={cssCreateAccount.txtInput}
                        type="email"
                        placeholder={window.gAppUI.LBL_UsernameEmailPlaceHolder} // Username (Email)
                        required
                        onFocus={(event) => UserNameOnFocusHandler(event)}
                        onBlur={(event) => UserNameOnBlurHandler(event)}
                        />
                    <div className={GetClsOnFocusTitle(showOnFocusTitleForUserName)}>
                        {window.gAppUI.LBL_UsernameEmailPlaceHolder}
                    </div>
                </div>
                <div className={cssCreateAccount.divInput}>
                    <input ref={mrefTxtPassword}
                        className={cssCreateAccount.txtInput}
                        type="password"
                        placeholder={window.gAppUI.LBL_PasswordPlaceHolder} // Password
                        required
                        onFocus={(event) => PasswordOnFocusHandler(event)}
                        onBlur={(event) => PasswordOnBlurHandler(event)}
                        />
                    <div className={GetClsOnFocusTitle(showOnFocusTitleForPassword)}>
                        {window.gAppUI.LBL_PasswordPlaceHolder}
                    </div>
                </div>
                <div className={cssCreateAccount.divInput}>
                    <input ref={mrefTxtConfirmPassword}
                        className={cssCreateAccount.txtInput}
                        type="password"
                        placeholder={window.gAppUI.LBL_ConfirmPasswordPlaceHolder} //"Confirm Password"
                        required
                        onFocus={(event) => ConfirmPasswordOnFocusHandler(event)}
                        onBlur={(event) => ConfirmPasswordOnBlurHandler(event)}
                        />
                    <div className={GetClsOnFocusTitle(showOnFocusTitleForConfirmPassword)}>
                        {window.gAppUI.LBL_ConfirmPasswordPlaceHolder}
                    </div>
                </div>
                <div className={cssCreateAccount.divInput}>
                    <input ref={mrefTxtFirstName}
                        className={cssCreateAccount.txtInput}
                        type="text"
                        placeholder={window.gAppUI.LBL_FirstNamePlaceHolder} //"First Name" 
                        required
                        onFocus={(event) => FirstNameOnFocusHandler(event)}
                        onBlur={(event) => FirstNameOnBlurHandler(event)}
                        />
                    <div className={GetClsOnFocusTitle(showOnFocusTitleForFirstName)}>
                        {window.gAppUI.LBL_FirstNamePlaceHolder}
                    </div>
                </div>
                <div className={cssCreateAccount.divInput}>
                    <input ref={mrefTxtLastName}
                        className={cssCreateAccount.txtInput}
                        type="text"
                        placeholder={window.gAppUI.LBL_LastNamePlaceHolder} //"Last Name"
                        required
                        onFocus={(event) => LastNameOnFocusHandler(event)}
                        onBlur={(event) => LastNameOnBlurHandler(event)}
                        />
                    <div className={GetClsOnFocusTitle(showOnFocusTitleForLastName)}>
                        {window.gAppUI.LBL_LastNamePlaceHolder}
                    </div>
                </div>
                <div className={cssCreateAccount.divButtonCreateAccount} onClick={() => CreateAccountOnTapHandler()}>{window.gAppUI.LBL_CreateAccount}</div>
                <div className={cssCreateAccount.divButtonBackToLogin} onClick={() => GoToLoginPageOnTapHandler()}>{window.gAppUI.LBL_BackToLogin}</div>
            </div>
        )
    }

    function RenderMainWrapper()
    {
        console.log(COMP_NAME + ".RenderMainWrapper: ", mblnIfNeed2GoToApplicationHomePage)
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            return (
                <div className={cssCreateAccount.divMain}>
                    <div className={cssCreateAccount.divBG}></div>
                    <div className={cssCreateAccount.divMask}></div>
                    {RenderFormContent()}
                    
                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                    {/* <PCLWindow ref="refPCLWindow" CallbackRef={this.PCLWindowCallback}/> */}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default CreateAccount